module.exports = __webpack_public_path__ + "img/lantern.1006a4bc.png";